import { getCRMRecords } from "../apis/crm";
import { useStoreCRMGetRecords } from "../stores/useStoreCRMGetRecords";
import { useSmartMutation } from "./useSmartMutation";

export const useCRMGetRecords = ({ onSuccess, onError } = {}) => {
  const { setCRMRecords } = useStoreCRMGetRecords();

  return useSmartMutation("get_crm_records", getCRMRecords, {
    zustandSetter: setCRMRecords,
    onSuccess: (data, variables, context) => {
      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
